import type { Stripe, StripeError, PaymentMethod as StripePaymentMethod } from '@stripe/stripe-js';

export async function noop(
	_stripe: Stripe,
	_paymentMethod: Partial<Pick<StripePaymentMethod, 'id'>> | string | undefined,
	_clientSecret: string,
): Promise<StripeError | undefined> {
	return Promise.resolve(undefined);
}
